import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  alertMsg: null,
  alertType: null,
};

export const alertSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    setAlertDefault: (state) => {
      state.alertMsg = null;
      state.alertType = null;
    },
    setSuccessAlert: (state, action) => {
      const { msg } = action.payload;
      state.alertMsg = msg;
      state.alertType = "success";
    },
    setErrorAlert: (state, action) => {
      const { error } = action.payload;
      state.alertMsg = error;
      state.alertType = "error";
    },
  },
});

export const { setAlertDefault, setSuccessAlert, setErrorAlert } =
  alertSlice.actions;

export default alertSlice.reducer;
